import { LocalStorageService } from 'project/src/app/modules/dashboard/shared/services/local-storage.service';
import type { Observable } from 'rxjs';
import { BehaviorSubject, skip } from 'rxjs';

import { inject, Injectable } from '@angular/core';

import { darkTheme } from './dark-theme.constant';
import { lightTheme } from './light-theme.constant';

// import { BrowserStorage } from '@core-lib';

const DARK_MODE_KEY = 'isDarkMode';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private isDarkMode$ = new BehaviorSubject<boolean>(false);
  private localStorageService = inject(LocalStorageService);

  private isDarkModeEnabled$(): Observable<boolean> {
    return this.isDarkMode$.asObservable().pipe(skip(1));
  }

  public init() {
    const isDarkMode = this.localStorageService.getValue<boolean>(DARK_MODE_KEY) || false;
    this.toggleTheme(isDarkMode);
  }

  private toggleTheme(isDarkMode: boolean): void {
    const theme = isDarkMode ? darkTheme : lightTheme;
    const root = document.documentElement;

    Object.entries({ ...theme }).forEach(([property, value]) => {
      root.style.setProperty(property, value);
    });

    // TODO enable this when the dark mode feature will be ready
    // this.localStorageService.setValue(DARK_MODE_KEY, isDarkMode);
    // this.isDarkMode$.next(isDarkMode);
  }
}
